import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { ReverseReleasedItemService } from '../../services/wealthlane-award-services/services/ReverseReleasedItemService';

const useDeleteReversedReleaseItems = (
    handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
    onClose?: () => void
): UseMutationResult<any, unknown, Array<string>, unknown> => {
    const queryClient = useQueryClient();

    return useMutation(
        async (releaseItemIds: Array<string>) => {
            return await handleRequest(
                ReverseReleasedItemService.deleteApiAwardApiAppReverseReleasedItemReversedReleaseItems(
                    releaseItemIds
                )
            );
        },
        {
            onSuccess: async (response: any) => {
                onClose && onClose();
                if (response !== null && response?.isSuccess) {
                    toast.success(
                        <ToastComponent label='Success' message={`${String(response?.message)}`} />
                    );
                    await queryClient.invalidateQueries('getTransactionsReleaseDetailList');
                    await queryClient.invalidateQueries('getTransactionsReleaseList');
                    await queryClient.invalidateQueries('releaseDetailById');

                } else {
                    toast.error(
                        <ToastComponent
                            label='Error'
                            message={`${String(response?.message ?? 'Failed to remove reversed release item')}`}
                        />,
                        { autoClose: false }
                    );
                }
            },
            onError: (err: any) => {
                onClose && onClose();
                console.log('error', err);
            },
        }
    );
};

export default useDeleteReversedReleaseItems;

